import React from 'react';
import ReactToggle from 'react-toggle';
import './styles.scss';

interface ToggleProps {
	name: string;
	text: string;
	checked?: boolean;
	onChange?: (name: string, checked: boolean) => void;
	isDisabled?: boolean;
}

class ToggleV6 extends React.Component<ToggleProps> {
	private handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		this.props.onChange?.(this.props.name, event.target.checked);
	};

	render() {
		const { checked, isDisabled, text } = this.props;

		return (
			<div className='togglev6'>
				<div className='react-toggle-box'>
					<ReactToggle checked={checked} icons={false} onChange={this.handleChange} disabled={isDisabled ?? false} />
				</div>
				<div className='react-toggle-text'>{text}</div>
			</div>
		);
	}
}

export default ToggleV6;
